module.exports = __webpack_public_path__ + "static/media/page04_two_girls.af52d1fe.png";